'use client';

import { c as _c } from "react/compiler-runtime";
import SvgClock from '@common/icon/SvgClock';
import SvgDelete from '@common/icon/SvgDelete';
import useEmblaCarousel from 'embla-carousel-react';
import type { MouseEvent } from 'react';
interface RecentSearchChipsProps {
  keywords: string[];
  onSelect: (keyword: string) => void;
  onRemove: (keyword: string) => void;
  onClearAll: () => void;
}
export function RecentSearchChips(t0) {
  const $ = _c(21);
  const {
    keywords,
    onSelect,
    onRemove,
    onClearAll
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      axis: "x",
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef] = useEmblaCarousel(t1);
  if (keywords.length === 0) {
    return null;
  }
  let t2;
  if ($[1] !== onRemove) {
    t2 = (e, keyword) => {
      e.stopPropagation();
      onRemove(keyword);
    };
    $[1] = onRemove;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleRemove = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex shrink-0 items-center gap-4"><SvgClock className="size-16 text-Gray-600" /><span className="text-Gray-600 typo-caption1">최근 검색어</span></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== handleRemove || $[5] !== keywords || $[6] !== onSelect) {
    let t5;
    if ($[8] !== handleRemove || $[9] !== onSelect) {
      t5 = keyword_0 => <div key={keyword_0} role="button" tabIndex={0} aria-label={`${keyword_0} 검색`} className="flex h-28 shrink-0 cursor-pointer items-center gap-4 rounded-xsmall bg-Gray-100 p-8" onClick={() => onSelect(keyword_0)} onKeyDown={e_0 => {
        if (e_0.key === "Enter") {
          onSelect(keyword_0);
        }
      }}><span className="text-Gray-800 typo-caption1">{keyword_0}</span><button type="button" aria-label={`${keyword_0} 삭제`} className="-m-4 size-16 p-4 flex-center" onClick={e_1 => handleRemove(e_1, keyword_0)}><SvgDelete className="size-8 text-Gray-600" /></button></div>;
      $[8] = handleRemove;
      $[9] = onSelect;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    t4 = keywords.map(t5);
    $[4] = handleRemove;
    $[5] = keywords;
    $[6] = onSelect;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div className="flex items-center gap-4">{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== emblaRef || $[14] !== t5) {
    t6 = <div ref={emblaRef} className="min-w-0 flex-1 overflow-hidden">{t5}</div>;
    $[13] = emblaRef;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== onClearAll) {
    t7 = <button type="button" className="shrink-0 text-Gray-600 typo-caption1 mobile-tablet:hidden" onClick={onClearAll}>전체 삭제</button>;
    $[16] = onClearAll;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div className="flex h-auto w-full items-center gap-16 px-8 mobile-tablet:border-b mobile-tablet:border-Gray-200 mobile-tablet:px-20 mobile-tablet:py-6">{t3}{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
}